import Comment from '@/models/Comment';
import CommentsService from '@/services/CommentsService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useCommentsStore = defineStore('comments', {
  state: () => ({}),

  getters: {
    models: () => useRepo(Comment),
  },

  actions: {
    async updateComment(commentId: Id, request: ApiRequests['api.v1.comments.update']) {
      const [data, error] = await CommentsService.update(commentId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async deleteComment(commentId: Id) {
      const [data, error] = await CommentsService.destroy(commentId);

      if(error) {
        throw error;
      }

      this.models.destroy(data.id);

      return data;
    },
  },
});
